import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCancel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "cancel",
		opacity: .8,
		d: "M8.27766 18.6536L12.5977 14.3336L16.9177 18.6536L18.5977 16.9736L14.2777 12.6536L18.5977 8.3336L16.9177 6.65359L12.5977 10.9736L8.27766 6.65359L6.59766 8.3336L10.9177 12.6536L6.59766 16.9736L8.27766 18.6536ZM12.5977 24.6536C10.9377 24.6536 9.37766 24.3386 7.91766 23.7086C6.45766 23.0786 5.18766 22.2236 4.10766 21.1436C3.02766 20.0636 2.17266 18.7936 1.54266 17.3336C0.912656 15.8736 0.597656 14.3136 0.597656 12.6536C0.597656 10.9936 0.912656 9.4336 1.54266 7.9736C2.17266 6.5136 3.02766 5.2436 4.10766 4.16359C5.18766 3.0836 6.45766 2.2286 7.91766 1.5986C9.37766 0.968595 10.9377 0.653595 12.5977 0.653595C14.2577 0.653595 15.8177 0.968595 17.2777 1.5986C18.7377 2.2286 20.0077 3.0836 21.0877 4.16359C22.1677 5.2436 23.0227 6.5136 23.6527 7.9736C24.2827 9.4336 24.5977 10.9936 24.5977 12.6536C24.5977 14.3136 24.2827 15.8736 23.6527 17.3336C23.0227 18.7936 22.1677 20.0636 21.0877 21.1436C20.0077 22.2236 18.7377 23.0786 17.2777 23.7086C15.8177 24.3386 14.2577 24.6536 12.5977 24.6536ZM12.5977 22.2536C15.2777 22.2536 17.5477 21.3236 19.4077 19.4636C21.2677 17.6036 22.1977 15.3336 22.1977 12.6536C22.1977 9.9736 21.2677 7.7036 19.4077 5.8436C17.5477 3.9836 15.2777 3.0536 12.5977 3.0536C9.91766 3.0536 7.64766 3.9836 5.78766 5.8436C3.92766 7.7036 2.99766 9.9736 2.99766 12.6536C2.99766 15.3336 3.92766 17.6036 5.78766 19.4636C7.64766 21.3236 9.91766 22.2536 12.5977 22.2536Z",
		fill: "currentColor",
		style: {
			fill: "currentColor",
			fillOpacity: 1
		}
	})
});
export default SvgCancel;
